class DropdownSelect extends React.Component {
  render () {
    const {input, options, defaultOption, id, dir} = this.props
    return (
      <label className='mk-select-label'>
        <select {...input} className={`mk-select`} id={id} dir={dir}>
          {defaultOption && <option value={defaultOption.id} selected='selected'>{defaultOption.name}</option>}
          {options.map((option) => (<option value={option.id}>{option.name}</option>))}
        </select>
      </label>)
  }
}

DropdownSelect.propTypes = {
}

export default DropdownSelect



// WEBPACK FOOTER //
// ./app/components/Fields/ReduxForm/DropdownSelect/DropdownSelect.js